import React, { Component } from 'react';


import moment, { Moment } from 'moment';

interface CurrentDateTimeContainerProps { 
 
};

interface CurrentDateTimeContainerState { 
  dateTime: string;
};


class CurrentDateTimeContainer extends Component <CurrentDateTimeContainerProps, CurrentDateTimeContainerState> {
  
  state = {
    dateTime: new Date().toLocaleString(),
  };

  componentDidMount(){

    this.intervalID = setInterval(
      () => this.tick(),
      1000
    );
    
  };

  componentWillUnmount() {
    clearInterval(this.intervalID);
  };

  tick(): void {
    this.setState({
      dateTime: new Date().toLocaleString()
    });
  };

  intervalID: ReturnType<typeof setTimeout> = setTimeout(() => {}, 0);

  
    
  render() {
    let newDt: Moment = moment(this.state.dateTime, 'MM/DD/YYYY, HH:mm:ss a');
    let dt: string = moment(newDt).format('DD MMM YY - hh:mm:ss a').toUpperCase();
  
    return (
      <span>{ dt } EST</span> 
    )
  };
};

export default CurrentDateTimeContainer ;